import React from "react";
import './Plans.css'
import whiteTick from '../../assets/whiteTick.png'
import {plansData} from '../../data/plansData'

const Plans=()=>{
    return(
        <div className="plans-container">
            <div className="blur blur-p1"></div>
            <div className="blur blur-p2"></div>

            <div className="programs-header" style={{gap:'2rem'}}>
                <span className="stroke-text">READY TO START</span>
                <span>YOUR JOURNEY</span>
                <span className="stroke-text">NOW WITHUS</span>
            </div>

            {/* plans card */}
            <div className="plans">
               { plansData.map((plan,i) => (
                <div className="plan" key={1}>
                    {plan.icon}
                    <span>{plan.name}</span>
                    <span className="price">${plan.price}</span>

                    <div className="features">
                        {plan.features.map((feature,i)=>(
                            <div className="feature">
                                <img src={whiteTick} alt="" />
                                <span key={1}>{feature}</span>
                            </div>
                        ))}
                    </div>
                    <div>
                        <span>See more benefits</span>
                        </div>
                        <button className="btn">Join Now</button>
                </div>
               ))}
            </div>
        </div>

    )
}
export default Plans;